import { render } from "./D_channelSkeleton.vue?vue&type=template&id=c00014c0"
import script from "./D_channelSkeleton.vue?vue&type=script&lang=js"
export * from "./D_channelSkeleton.vue?vue&type=script&lang=js"

import "./D_channelSkeleton.vue?vue&type=style&index=0&id=c00014c0&lang=scss"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__